import React from 'react';
// import { DeleteButton, EditButton, ShowButton } from '@refinedev/antd';
import { Button, Popconfirm, Space, Tag } from 'antd';
import { ColumnType } from '@/types';
import { PauseCircleOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { ShowButton } from '@refinedev/antd';
import { joinMaxThree } from '@/Helpers';

export const getColumns = (
  translate: (key: string) => string,
  handlePublishId: (id: number) => void,
  handlePublish: () => void,
  adminType?: string
): ColumnType[] => [
  {
    title: translate('listing-posts.id'),
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: translate('listing-posts.post-title'),
    dataIndex: 'title',
    key: 'title',
    render: (value) => (value ? `${value?.slice(0, 20)}...` : '-'),
  },
  {
    title: translate('listing-posts.summary'),
    dataIndex: 'summary',
    key: 'summary',
    render: (value) => (value ? `${value?.slice(0, 20)}...` : '-'),
  },
  {
    title: translate('listing-posts.type'),
    dataIndex: 'type',
    key: 'type',
    render: (value) => translate(`listing-posts.type.${value}`),
  },
  {
    title: translate('listing-posts.topics'),
    dataIndex: 'topics',
    key: 'topics',
    render: (value) =>
      joinMaxThree(value.map((topic: { name: string }) => topic.name)),
  },
  {
    title: translate('listing-posts.is_published'),
    dataIndex: 'is_published',
    key: 'is_published',
    render: (value) =>
      value ? (
        <Tag color="green">{translate('listing-posts.published')}</Tag>
      ) : (
        <Tag color="red">{translate('listing-posts.unpublished')}</Tag>
      ),
  },
  {
    title: translate('listing-posts.is_featured'),
    dataIndex: 'is_featured',
    key: 'is_featured',
    render: (value) =>
      value ? (
        <Tag color="green">{translate('listing-posts.featured')}</Tag>
      ) : (
        <Tag color="red">{translate('listing-posts.not_featured')}</Tag>
      ),
  },
  {
    title: translate('listing-posts.actions'),
    dataIndex: 'actions',
    key: 'actions',
    render: (_, record) => (
      <Space>
        {adminType !== 'ACADEMIC_SUPERVISOR' &&
          adminType !== 'PROGRAM_HEAD' && (
            <Popconfirm
              placement="right"
              title={
                !record.is_published
                  ? translate('listing-posts.publish-confirm')
                  : translate('listing-posts.unpublish-confirm')
              }
              onConfirm={() => {
                handlePublish();
              }}
              okText={translate('listing-posts.ok')}
              cancelText={translate('listing-posts.cancel')}
            >
              <Button
                icon={
                  !record.is_published ? (
                    <PlayCircleOutlined className="text-green-500" />
                  ) : (
                    <PauseCircleOutlined className="text-red-500" />
                  )
                }
                className={
                  !record.is_published ? 'border-green-500' : 'border-red-500'
                }
                size="small"
                onClick={() => handlePublishId(record.id)}
              />
            </Popconfirm>
          )}
        <ShowButton hideText size="small" recordItemId={record.id} />
      </Space>
    ),
  },
];
